import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_30: FaireProductEntity = {
  token: "legacy_prod_abbott-30",
  type: "product",
  name: 'Tall Bud Vase Dark Blue 7.5" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a1e21f0fe85b9e1abb8340271026f8c33eb6364831b062cf4a7195521f0efac0.jpeg",
  priceDollars: 18,
  subcategory: "Vases & Vessels",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
